var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRouletteWinnerBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x2014_\\xCE\\xD3\\xC8_x5F_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 456.58 229.51",
    style: {
      enableBackground: "new 0 0 456.58 229.51"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FFE94D;}\n\t.st2{fill:#FFC3E0;}\n\t.st3{fill:#E72E5C;}\n\t.st4{fill:#FFDA3E;}\n\t.st5{fill:#1DB3DB;}\n\t.st6{fill:#E0D5B3;}\n\t.st7{fill:#871233;}\n\t.st8{fill:#FFEA6C;}\n\t.st9{fill:#EFE8CE;}\n\t.st10{fill:#FFED10;}\n\t.st11{fill:none;stroke:#E72E5C;stroke-width:8;stroke-miterlimit:10;}\n\t.st12{fill:#FFB8D3;}\n\t.st13{fill:none;stroke:#E0D5B3;stroke-width:6;stroke-miterlimit:10;}\n\t.st14{fill:none;stroke:#E72E5C;stroke-width:5;stroke-miterlimit:10;}\n\t.st15{clip-path:url(#SVGID_00000042010348813617495710000013057561052230240396_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M440.88,3.44H15.04c-4.26,0-7.72,3.46-7.72,7.72v206.23c0,4.26,3.46,7.72,7.72,7.72h425.85 c4.26,0,7.72-3.46,7.72-7.72V11.16C448.6,6.9,445.15,3.44,440.88,3.44z M418.39,188.41c0,1.42-1.15,2.58-2.58,2.58H43.83 c-1.42,0-2.58-1.15-2.58-2.58V38.95c0-1.42,1.15-2.58,2.58-2.58h371.98c1.42,0,2.58,1.15,2.58,2.58V188.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M443.69,225.51H12.89c-4.91,0-8.89-3.98-8.89-8.89V12.89C4,7.98,7.98,4,12.89,4h430.8 c4.91,0,8.89,3.98,8.89,8.89v203.72C452.58,221.52,448.6,225.51,443.69,225.51z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.25,
    y: 41.9,
    className: "st13",
    width: 372.78,
    height: 149.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M415.82,191.57H43.83c-1.42,0-2.58-1.15-2.58-2.58V39.78c0-1.42,1.15-2.58,2.58-2.58h371.98 c1.42,0,2.58,1.15,2.58,2.58V189C418.39,190.42,417.24,191.57,415.82,191.57z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 85.37,
    cy: 20.58,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 154.92,
    cy: 20.58,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 225.11,
    cy: 20.58,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 294.84,
    cy: 20.58,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 365.11,
    cy: 20.58,
    r: 8.07
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 23.84,
    cy: 23.51,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 23.84,
    cy: 152.36,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 23.84,
    cy: 79.6,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 85.37,
    cy: 208.92,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 154.92,
    cy: 208.92,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 225.11,
    cy: 208.92,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 294.84,
    cy: 208.92,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 365.11,
    cy: 208.92,
    r: 8.07
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 23.84,
    cy: 207.37,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 435.66,
    cy: 22.57,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 435.66,
    cy: 152.36,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 435.66,
    cy: 79.6,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 435.66,
    cy: 208.02,
    r: 8.07
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouletteWinnerBorder);
export default __webpack_public_path__ + "static/media/roulette-winner-border.c18b2813a348c9bf738d9037e6a9efb5.svg";
export { ForwardRef as ReactComponent };